import { Component, Host, h } from "@stencil/core";

/**
 * @slot - Slot for any elements
 */
@Component({
  tag: "stzh-visuallyhidden",
  styleUrl: "stzh-visuallyhidden.scss",
  scoped: true,
})
export class StzhVisuallyhidden {
  render() {
    return (
      <Host>
        <div
          class={{
            "stzh-visuallyhidden": true,
          }}
        >
          <slot></slot>
        </div>
      </Host>
    );
  }
}
